// Scroll add to cart
document.addEventListener('scroll', function () {
  // Var has been used to allow Shopify to minify the code. Const fails minimisation.
  var scrollAddToCartElement = document.querySelector('.scroll-add-to-cart__wrapper');
  if (window.scrollY > 800) {
    scrollAddToCartElement.style.display = 'block';
    scrollAddToCartElement.classList.add('active');
  } else {
    scrollAddToCartElement.style.display = 'none';
    scrollAddToCartElement.classList.remove('active');
  }
});

// Update variant ID and selected option text
const scrollAddToCartOptions = document.querySelector('.scroll-add-to-cart__options');
const radioButtons = [...scrollAddToCartOptions.querySelectorAll('[data-swatch-input]')];
const selectedOptionText = document.querySelector('[data-swapper-target]');


if (selectedOptionText && radioButtons.length > 1) {
  radioButtons.map((radioButton) => {
    radioButton.addEventListener('click', (event)=> {

      // Update the selected option text
      selectedOptionText.innerText = radioButton.value;

      // Get form hidden input and update variant ID from data attribute on radio button
      const atcID = document.querySelector('.scroll-add-to-cart__button [name="id"]');
      const dataVariant = radioButton.dataset.variant;
      atcID.value = dataVariant;
  
    });
  });
}


